module.exports = __webpack_public_path__ + "img/giveaway-placeholder.211a598a.jpg";